/*
Version 0.115

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2018.

!Changelog

2021
	20-01-2021
	- [BORN] This class is born. Hooray!

!Usage
	specific_mobilemenu.onready();

	
!Wishlist

	none
	
*/
  
var specific_explainer = {};

(function(){
	 
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************

	this.onready = function() {

		_videoplayer 		= $('.js-explainer-video')[0];

		specific_explainer.switchVideo(1);
		localStorage.setItem("video_id", "1");

		 _videoplayer.onended = function(e) {

		 	switch(
		 		localStorage.getItem("video_id")
		 	) {
		 		case '1':
		 			specific_explainer.switchVideo(2);
		 			localStorage.setItem("video_id", "2");
		 		break;
		 		case '2':
		 			specific_explainer.switchVideo(3);
		 			localStorage.setItem("video_id", "3");
		 		break;
		 		case '3':
		 			specific_explainer.switchVideo(4);
		 			localStorage.setItem("video_id", "4");
		 		break;
		 		case '4':
		 			specific_explainer.switchVideo(1);
		 			localStorage.setItem("video_id", "1");
		 		break;
		 	}

		 	
		 };

		/*
		Input 1
		*/
		$(document).on('click','.js-explainer-item-click',function(){

			var _id 	= $(this).parent().data('item');

			localStorage.setItem("video_id", _id);

			specific_explainer.switchVideo(_id);

		});
		
	};
	 
	// METHODS  *****************************************************************
	// METHODS *****************************************************************
	// METHODS ******************************************************************
	// METHODS ******************************************************************
	
	this.switchVideo = function(id) {

		/*
		Set: Active item
		*/
		$('.js-explainer-item').removeClass('active');
		$('.js-explainer-item-' + id).addClass('active');

		/*
		Switch video
		*/
		$('.js-explainer-video').fadeOut(200,function() {

			_videoplayer 		= $('.js-explainer-video')[0];
			_videoplayer.src 	= globalUrl + '/doc/static/explainer-' + id + '.mp4';
			_videoplayer.load();
			_videoplayer.play();

			$('.js-explainer-video').fadeIn(200);

		});

	};
		
}).apply(specific_explainer); 